/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Promotion13Inputs */

const en__field_enum_tuda_promotion13 = /** @type {(inputs: _Field_Enum_Tuda_Promotion13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

const de__field_enum_tuda_promotion13 = /** @type {(inputs: _Field_Enum_Tuda_Promotion13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

/**
* | output |
* | --- |
* | "Promotion" |
*
* @param {_Field_Enum_Tuda_Promotion13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_promotion13 = /** @type {((inputs?: _Field_Enum_Tuda_Promotion13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Promotion13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_promotion13(inputs)
	return de__field_enum_tuda_promotion13(inputs)
});
export { _field_enum_tuda_promotion13 as "_field_enum_TUDA_PROMOTION" }